/**
 * Vehicle body type values
 */
export enum VehicleBodyTypeEnum {
	SEDAN = 'sedan',
	COUPE = 'coupe',
	CONVERTIBLE = 'convertible',
	ROADSTER = 'roadster',
	HATCHBACK = 'hatchback',
	WAGON = 'wagon',
	SUV = 'suv',
	CUV = 'cuv',
	STREETCAR = 'streetcar',
	PICKUP = 'pickup',
	TRAILER = 'trailer',
	MINIVAN = 'minivan',
	CAMPER = 'camper',
	VAN = 'van',
	TRUCK = 'truck',
	BUS = 'bus',
	TRACTOR = 'tractor',
	BUGGY = 'buggy',
	QUAD_BIKE = 'quad_bike',
	SNOWMOBILE = 'snowmobile',
	BICYCLE = 'bicycle',
	SCOOTER = 'scooter',
	MOTORCYCLE = 'motorcycle',
	OTHER = 'other',
	JEEP = 'jeep',
	JEEP4x4 = 'jeep-4x4',
	E_BIKE = 'e_bike',
}
